<template>
  <div class="asc-legend-container">
    <asc-accordion :value="0">
      <asc-accordion-item first>
        <template slot="header">Legend</template>
        <asc-legend-list :filter="false" :items="items"></asc-legend-list>
      </asc-accordion-item>
    </asc-accordion>
  </div>
</template>

<script>
import AscLegendList from '@/components/molecules/AscLegendList'
import AscAccordion from '@/components/atoms/AscAccordion'
import AscAccordionItem from '@/components/atoms/AscAccordionItem'

export default {
  name: 'AscLegend',

  components: { AscLegendList, AscAccordion, AscAccordionItem },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss">
.asc-legend-container {
  padding: 16px;

  .asc-accordion {
    .asc-accordion--item {
      &.asc-acordion--item-open {
        .asc-accordion--item--content {
          padding-top: 10px;
        }
      }
    }
  }
}
</style>
